/*
 * Copyright © 2015-2018 Serenova, LLC. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { SearchIconSVG } from 'cx-ui-components';

const Input = styled.input`
  width: 100%;
`;
const SearchIcon = styled(SearchIconSVG)`
  position: relative;
  left: -17px;
  opacity: 0.4;
`;

export const activePolicyColumn = {
  id: 'activePolicy',
  Header: <span title="Active Policy">Active Version</span>,
  accessor: "version",
  Cell: ({ value }) => <span title={value}>v{value}</span>,
  Filter: ({ filter, onChange }) => (
    <div>
      <Input
        onChange={event => onChange(event.target.value)}
        value={filter ? filter.value : ''}
        placeholder="Version"
      />
      <SearchIcon searchIconType="primary" size={10} />
    </div>
  )
};

activePolicyColumn.Cell.propTypes = {
  value: PropTypes.any
};
activePolicyColumn.Filter.propTypes = {
  filter: PropTypes.func,
  onChange: PropTypes.func
};
